import HeroImage from './hero-image'
import TestimonialCarousel from './testimonial-carousel/TestimonialCarousel'
import TextWithLateralMedia from './text-with-lateral-media'
import ExternalLogoLists from './external-logo-lists'
import HeadlineWithDescription from './headline-with-description'
import FAQs from './faqs'
import OverlappingTextWithCta from './overlapping-text-with-cta'
import NumbersCarousel from './numbers-carousel'
import TabularUSPs from './tabular-usps'
import Spacer from './spacer'
import ConnectedCards from './connected-cards'
import IconListWithText from './icon-list-with-text'
import SimpleCards from './simple-cards'
import ContactDetails from './contact-details'
import FlippableCards from './flippable-cards'
import ImageSlider from './image-slider'
import SignupHeroMedia from './signup-hero-media'
import VideoComponent from './video-component'
import AudioComponent from './audio-component'
import WysiwygComponent from './wysiwyg-component/WysiwygComponent'
import {IframeButton} from './iframe-dialog'
import USPs from './usps'
import SignupFormComponent from './signup-form-component'
import Button from './button/Button'
import CardsCarousel from './cards-carousel'
import HoverCards from './hover-cards'

export const componentsMap: Record<string, any> = {
  hero_image: HeroImage,
  text_with_lateral_media: TextWithLateralMedia,
  external_logo_lists: ExternalLogoLists,
  headline_with_description: HeadlineWithDescription,
  faqs: FAQs,
  overlapping_text_with_cta: OverlappingTextWithCta,
  testimonial_carousel: TestimonialCarousel,
  number_carousel: NumbersCarousel,
  tabular_usps: TabularUSPs,
  spacer: Spacer,
  connected_cards: ConnectedCards,
  icon_list_with_text: IconListWithText,
  simple_cards: SimpleCards,
  contact_details: ContactDetails,
  flippable_cards: FlippableCards,
  image_slider: ImageSlider,
  signup_hero_media: SignupHeroMedia,
  video_component: VideoComponent,
  audio_component: AudioComponent,
  wysiwyg_component: WysiwygComponent,
  iframe_dialog: IframeButton,
  usps: USPs,
  signup_form_component: SignupFormComponent,
  button: Button,
  cards_carousel: CardsCarousel,
  hover_cards: HoverCards,
}
